;
function initMap() {
    var container = document.getElementById('map');

    if (container) {
        var $locations = $('#locations li');

        if ($locations.length) {
            locationsMap(container, $locations);
        } else {
            contactMap(container);
        }
    }
}

function locationsMap(container, $destinations) {
    var center = {
        lat: -24.666732,
        lng: -56.459492
    };

    var map = new google.maps.Map(container, {
        zoom: 6,
        center: center
    });

    $destinations.each(function () {
        var position = {
            lat: parseFloat($(this).data('lat')),
            lng: parseFloat($(this).data('lng'))
        };

        new google.maps.Marker({
            position: position,
            map: map,
            title: $(this).data('name')
        });
    });
}

function contactMap(container) {
    var position = {
        lat: -25.354191,
        lng: -57.588665
    };

    var map = new google.maps.Map(container, {
        zoom: 16,
        center: position
    });

    new google.maps.Marker({
        position: position,
        map: map,
        title: '1º de Mayo y Chaco Boreal, Villa Elisa, Paraguay'
    });
}